/**
 * Method to set value in reducer.
 */
export function setCart(cart = {}) {
  return {
    type: 'SET_CART_DATA',
    cart
  };
}

export function updateCartSummary(orderSummary = {}) {
  return {
    type: 'UPDATE_CART_SUMMARY',
    orderSummary
  };
}
export function cartItemData(cartItem = []) {
  return {
    type: 'SET_CART_ITEM_DATA',
    cartItem
  };
}

export function giftItemData(giftItem = []) {
  return {
    type: 'SET_GIFT_ITEM_DATA',
    giftItem
  };
}



export function getCartSuccess() {
  return {
    type: 'GET_CART_SUCCESS',
    success: true
  };
}

export function getCartFail(error) {
  return {
    type: 'GET_CART_FAIL',
    success: false
  };
}

export function updateToCartError(cartError, cartResponse) {
  return {
    type: 'ADD_TO_CART_ERROR',
    cartError,
    cartResponse
  };
}

export function setVouchers(vouchers) {
  return {
    type: 'GET_VOUCHER',
    vouchers
  };
}

export function removeVoucher() {
  return {
    type: 'REMOVE_VOUCHER',
    voucher: {}
  };
}

export function removeCard(key, value) {
  return {
    type: 'REMOVE_MERGE_OOS_LIMITED_STOCK_CARD',
    key,
    value
  };
}

export function setSizeDetails(size) {
  return {
    type: 'GET_SIZE_DETAILS_CART',
    size
  };
}

export function getProductSize(size) {
  return {
    type: 'GET_PRODUCT_SIZE',
    size
  };
}

export function setAjioWalletEarnData(ajioWalletEarnData = {}) {
  return {
    type: 'SET_AJIOWALLET_EARN_DATA',
    ajioWalletEarnData
  };
}

export function setCartInventoryCheck(items = []) {
  return {
    type: 'SET_CART_INVENTORY_CHECK',
    items
  };
}

export function setInternalWallet(wallet) {
  return {
    type: 'SET_INTERNAL_WALLET',
    wallet
  };
}

export function resetCartErrors() {
  return {
    type: 'RESET_CART_ERRORS'
  }
}
// //cart[key] = {
//     ...cart[key] , cardToShow : false
// }
